import classNames from 'classnames'
import imgAmericanExpress from 'legacy/lut/assets/img/payment__american-express.png'
import imgBankTransfer from 'legacy/lut/assets/img/payment__bank-transfer.svg'
import imgCash from 'legacy/lut/assets/img/payment__cash.svg'
import imgCheck from 'legacy/lut/assets/img/payment__check.svg'
import imgMaestro from 'legacy/lut/assets/img/payment__maestro.png'
import imgMastercard from 'legacy/lut/assets/img/payment__mastercard.svg'
import imgPayPal from 'legacy/lut/assets/img/payment__paypal.svg'
import imgVisa from 'legacy/lut/assets/img/payment__visa.svg'
import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'
import { JSX, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './Payments.module.scss'

interface IProps {
  paymentTypes: IFormCategories[]
}

const Payments = (props: IProps) => {
  const { paymentTypes } = props
  const [payments, setPayments] = useState<JSX.Element>(<></>)

  useMemo(() => {
    if (paymentTypes.length < 1) {
      setPayments(
        <div className={styles['payment-methods__item']}>
          <Translation text={'partner-preview-empty'} />
        </div>
      )
      return (
        <div className={styles['payment-methods__item']}>
          <Translation text={'partner-preview-empty'} />
        </div>
      )
    }
    const result: any = []
    const itemArray = paymentTypes
    const getImage = (caseName: any) => {
      if (caseName === 'Visa')
        return (
          <img
            className={classNames(styles.item__img, styles['item__img--visa'])}
            src={imgVisa}
            alt="Visa"
            title="Visa"
          />
        )
      else if (caseName === 'Mastercard')
        return (
          <img
            className={styles.item__img}
            src={imgMastercard}
            alt="Mastercard"
            title="Mastercard"
          />
        )
      else if (caseName === 'PayPal')
        return <img className={styles.item__img} src={imgPayPal} alt="PayPal" title="PayPal" />
      else if (caseName === 'Maestro')
        return <img className={styles.item__img} src={imgMaestro} alt="Maestro" title="Maestro" />
      else if (caseName === 'American Express')
        return (
          <img
            className={styles.item__img}
            src={imgAmericanExpress}
            alt="American Express"
            title="American Express"
          />
        )
      else if (caseName === 'Cash')
        return <img className={styles.item__img} src={imgCash} alt="Cash" title="Cash" />
      else if (caseName === 'Check')
        return <img className={styles.item__img} src={imgCheck} alt="Check" title="Check" />
      else if (caseName === 'Bank Transfer')
        return (
          <img
            className={styles.item__img}
            src={imgBankTransfer}
            alt="Bank Transfer"
            title="Bank Transfer"
          />
        )
      else return caseName
    }
    for (let i = 0; i < itemArray.length; i++) {
      result.push(
        <div className={styles.item} key={`paymentMethod_${i}`}>
          {getImage(itemArray[i].name)}
        </div>
      )
    }
    setPayments(result)
    return result
  }, [paymentTypes.join(',')])

  return payments
}

export default Payments
